import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type OauthPageStore } from 'pages/auth/pages/oauth/store/oauthPageStore'

export const OauthPageContext = createContext<OauthPageStore | null>(null)

export const useOauthPageContext = () => {
  const context = useContext(OauthPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with OauthPageContext')

  return context
}

type IProviderOauthPageProps = {
  value: OauthPageStore
  children: ReactNode
}

export const ProviderOauthPage: FC<IProviderOauthPageProps> = ({ value, children }) => {
  return <OauthPageContext.Provider value={value}>{children}</OauthPageContext.Provider>
}
